export const getImageUrl = (imageName) => {
    return `/images/${imageName}`;
  };
  
  export const fallbackImage = '../assets/images/class.jpg';